export interface ScheduledCompletionItem {
    itemName?: string | null;
    name?: string | null;
    completed?: boolean | null;
    quantity?: number | null;
    manufacturer?: string | null;
    partNumber?: string | null;
    itemType?: string | null;
    vendorName?: string | null;
}

export function isProcedureItem(itemType?: string | null): boolean {
    const value = (itemType || '').trim().toLowerCase();
    return value === 'procedure';
}

/** Scheduled matrix rows the shop did not mark done. */
export function incompleteScheduledItems<T extends { completed?: boolean | null }>(items: T[]): T[] {
    return items.filter((item) => item.completed !== true);
}

export function formatIncompleteItemLine(item: ScheduledCompletionItem): string {
    const name = (item.itemName || item.name || 'Item').trim() || 'Item';
    const parts = [
        name,
        isProcedureItem(item.itemType) ? 'Procedure' : '',
        item.quantity != null && item.quantity > 0 ? `Qty ${item.quantity}` : '',
        item.manufacturer?.trim() || '',
        item.partNumber?.trim() || '',
    ].filter(Boolean);
    return parts.join(' · ');
}

export function normalizeRecipientEmails(emails: (string | null | undefined)[] | null | undefined): string[] {
    return [...new Set((emails ?? []).map((email) => (email || '').trim().toLowerCase()).filter(Boolean))];
}
